module.exports = __webpack_public_path__ + "static/media/agenda-icon.7eef0668.svg";